import { createSlice } from "@reduxjs/toolkit";

const initialnotificationState = {
    isInfoContainerOpen: false,   
    infoContainer: null, 
    notifications: [],
    lastNotificationSignature: null,
    lastNotificationAt: 0,
    lastQuickUpdateSuccessAt: 0,
}

const notificationSlice = createSlice({
    name: 'various',
    initialState: initialnotificationState,
    reducers: {
        setIsInfoContainerOpened(state) {
            state.isInfoContainerOpen = !state.isInfoContainerOpen
        },
        setIsInfoContainer(state, data) {
            state.infoContainer = data.payload
        },
        setError(state, data) {
            const dataBody = { ...(data.payload || {}) }
            const now = Date.now()
            const signature = `${dataBody.type || ''}:${dataBody.errorMessage || ''}`
            const isSuccess = dataBody.type === 'success'
            const isDuplicateSuccess =
                isSuccess &&
                state.lastNotificationSignature === signature &&
                (now - state.lastNotificationAt) < 1500

            if (isDuplicateSuccess) {
                return
            }

            dataBody.id = parseInt(Math.random() * 10000000)
            state.notifications.push(dataBody)
            state.lastNotificationSignature = signature
            state.lastNotificationAt = now
        },
        setQuickUpdateSaved(state) {
            const now = Date.now()
            const minGapMs = 2000
            if ((now - state.lastQuickUpdateSuccessAt) < minGapMs) {
                return
            }

            const dataBody = {
                id: parseInt(Math.random() * 10000000),
                errorMessage: 'Your changes have been successfully saved to the case.',
                type: 'success',
            }
            state.notifications.push(dataBody)
            state.lastQuickUpdateSuccessAt = now
            state.lastNotificationSignature = `${dataBody.type}:${dataBody.errorMessage}`
            state.lastNotificationAt = now
        },
        removeError(state, data) {
            const index = state.notifications.findIndex(object => {
                return object.id == data.payload.id
            })
            state.notifications.splice(index, 1)
        }
    }
})

export const notificationActions = notificationSlice.actions

export default notificationSlice.reducer